// extracted by mini-css-extract-plugin
export default {"bounce":"S_fh","loading":"S_fj","logo-mark-bounce-right":"S_fk","logo-mark-bounce-left":"S_fl"};